//removeIf(production)
import ClaroluzData from "../../domain/entities/claroluz-data";
import IClaroluzDataRepository from "../../domain/repositories/i-claroluz-data-repository";
import ClaroluzError from "../../errors/claroluz-errors";
import IClaroluzDataDatasource from "../datasources/i-claroluz-data-datasource";
import ExternalStatus from "../../enums/external-status";
import ValidateMimeType from "../../domain/usecases/validate-mime-type";
import FloatWithTwoDecimals from "../../domain/entities/float-with-two-decimals";
import ValidateCups from "../../domain/usecases/validate-cups";
import UrlDataExtract from "../../domain/usecases/url-data-extract";
import ClaroluzCupsData from "../../domain/entities/claroluz-cups-data";
//endRemoveIf(production)

class ClaroluzDataRepository implements IClaroluzDataRepository {
    private datasource: IClaroluzDataDatasource;

    constructor(datasource: IClaroluzDataDatasource) {
        this.datasource = datasource;
    }

    async getOffersByPdf(data: string): Promise<ClaroluzData> {
        try {
            if (!ValidateMimeType.of(data)) {
                return Promise.resolve(new ClaroluzData(ExternalStatus.CLAROLUZ_INVALID_PDF));
            }

            const response = await this.datasource.getOffersByPdf(data, ValidateMimeType.getMimeType(data));
            return response;
        } catch (error) {
            if (appProperties().debug) {
                console.log(error);
            }

            if (error instanceof ClaroluzError) {
                return Promise.resolve(new ClaroluzData(error.status));
            }

            return Promise.resolve(new ClaroluzData(ExternalStatus.CLAROLUZ_UNKNOWN_ERROR));                        
        }
    }

    async getOffersByCups(data: ClaroluzCupsData): Promise<ClaroluzData>{
        try {
            if (!ValidateCups.of(data.cups)) {
                return Promise.resolve(new ClaroluzData(ExternalStatus.CLAROLUZ_INVALID_CUPS));
            }

            if (data.price.value < 1) {
                return Promise.resolve(new ClaroluzData(ExternalStatus.CLAROLUZ_INVALID_CUPS_VALUE));
            }

            const response = await this.datasource.getOffersByCups(data);
            return response;
        } catch (error) {
            if (appProperties().debug) {
                console.log(error);
            }

            if (error instanceof ClaroluzError) {
                return Promise.resolve(new ClaroluzData(error.status));
            }

            return Promise.resolve(new ClaroluzData(ExternalStatus.CLAROLUZ_UNKNOWN_ERROR));      
        }
    }
    
    async getOffersByUrl(data: string): Promise<ClaroluzData> {
        try {
            const billInfo = UrlDataExtract.of(data);

            if (!billInfo) {
                return Promise.resolve(new ClaroluzData(ExternalStatus.CLAROLUZ_INVALID_URL));
            }

            const response = await this.datasource.getOffersByUrl(data);
            return response;
        } catch (error) {
            if (appProperties().debug) {
                console.log(error);
            }

            if (error instanceof ClaroluzError) {
                return Promise.resolve(new ClaroluzData(error.status));
            }

            return Promise.resolve(new ClaroluzData(ExternalStatus.CLAROLUZ_UNKNOWN_ERROR)); 
        }
    }
}

//removeIf(production)
export default ClaroluzDataRepository;

function appProperties(): import("../../infra/critical/claroluz-events-properties").default {
    throw new Error("Function not implemented.");
}
//endRemoveIf(production)